<template>
    <div class="footer">
        <a-row justify="center">
            <a-col :span="10">
                <div class="footer-l">
                    <img src="@/assets/img/logo.png" ref="imgRef">
                    <br />
                    <p>让科技 联结起美好生活</p>
                    <span>实现可持续的业务增长和创新发展</span>
                </div>
            </a-col>
            <a-col :span="10">
                <div class="footer-r">
                    <div class="phone">
                        <img src="@/assets/img/phone-icon.png">
                        <div>
                            <span>联系电话：</span>
                            <br />
                            <span style="font-size: 24px;font-weight: 600;">400-811-9585</span>
                        </div>
                    </div>
                    <div class="QR-code-item">
                        <img src="@/assets/img/qr-1.png">
                        合作微信
                    </div>
                    <div class="QR-code-item">
                        <img src="@/assets/img/qr-2.png">
                        客服微信
                    </div>
                </div>
            </a-col>
        </a-row>
        <p class="record">
            <a-space :size="16">
                <span><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">粤ICP备19099034号</a></span>
                <span> Copyright@Aline All Rights Reserved </span>
                <span>广东亚联科技有限公司 版权所有</span>
            </a-space>
        </p>
    </div>
</template>

<style lang="less" scoped>
.footer {

min-width: 1200px;
height: 400px;
background: #EA2709;
position: relative;
display: flex;
flex-direction: column;
justify-content: center;

.footer-l {
  height: 100%;
  color: #fff;

  img {
    height: 44px;
    width: 131px;
  }

  p {
    margin: 16px 0;
    font-size: 16px;
    font-weight: 500;
  }

  span {
    font-size: 24px;
    font-weight: 500;
  }
}

.footer-r {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .phone {
    display: flex;
    color: #fff;
    height: 50px;
    align-items: center;

    img {
      width: 42px;
      margin-right: 10px;
    }
  }

  .QR-code-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-left: 24px;

    img {
      width: 126px;
      margin-bottom: 11px;
    }
  }
}

.record {
  width: 100%;
  position: absolute;
  bottom: 32px;
  text-align: center;
  color: #fff;
  font-size: 12px;
}
}
</style>